import { Progress, Stack, Text } from '@mantine/core';
import type { JobProgress } from '../../../types/job';

interface JobProgressCellProps {
  progress: JobProgress;
}

function progressLabel(progress: JobProgress): string {
  if (progress.total === null) return 'streaming…';
  const done = progress.succeeded + progress.failed + progress.cancelled;
  const parts = [`${done}/${progress.total}`];
  if (progress.failed > 0) parts.push(`${progress.failed} failed`);
  if (progress.cancelled > 0) parts.push(`${progress.cancelled} cancelled`);
  return parts.join(' · ');
}

function toPercent(count: number, total: number): number {
  return total > 0 ? (count / total) * 100 : 0;
}

export function JobProgressCell({ progress }: JobProgressCellProps) {
  return (
    <Stack spacing={4} sx={{ minWidth: 140 }}>
      {progress.total === null ? (
        <Progress size="sm" value={100} striped animate color="blue" />
      ) : (
        <Progress
          size="sm"
          sections={[
            { value: toPercent(progress.succeeded, progress.total), color: 'green' },
            { value: toPercent(progress.failed, progress.total), color: 'red' },
            { value: toPercent(progress.cancelled, progress.total), color: 'gray' },
          ]}
        />
      )}
      <Text size="xs" color="dimmed">
        {progressLabel(progress)}
      </Text>
    </Stack>
  );
}
